import cn from 'classnames';
import React, { useCallback } from 'react';
import { useAppDispatch } from '@app/hooks';
import { Dialog } from '@react-md/dialog';
import { PopupProps } from '@types';
import { popupsActions } from '@modules/ui';
import { SignInBody } from './sign-in-body';
import { SignInFooter } from './sign-in-footer';
import { signInId } from '../helpers';

import styles from '../auth-page.module.scss';

export const SignInPopup: React.FC<PopupProps> = ({ isOpened, isClosable }) => {
    const dispatch = useAppDispatch();
    const close = useCallback(() => dispatch(popupsActions.close()), [dispatch]);

    return (
        <Dialog
            id={signInId('popup')}
            visible={isOpened}
            onRequestClose={() => (isClosable ? close() : {})}
            aria-labelledby={signInId('popup')}
            overlayStyle={{ transition: 'none' }}
            // defaultFocus={`#${composeNodeId(SignInFormId, 'email', 'field')}`}
            disableFocusOnMount
            portal={false}
            modal={!isClosable}
            appear
        >
            <div className={cn('rounded-box', styles.box)}>
                <SignInBody onSuccess={close} />
                <SignInFooter type="popup" />
            </div>
        </Dialog>
    );
};
